import * as React from 'react';
import * as classes from './vendor-info.scss';

export interface VendorInfoDefaultRatingComponentProperties {
  readonly invoicePricing: number;
  readonly vendorRelations: number;
  readonly customerRelations: number;
}

export class VendorInfoDefaultRatingComponent extends React.Component<VendorInfoDefaultRatingComponentProperties> {
  render() {
    return (
      <section className={[classes.summary, 'row col-md-12'].join(' ')}>
        <div className={[classes.summaryCardRight, 'col-md-12 light-gray-bc'].join(' ')}>
          <div className="col-xs-12">
            <div className="row">
              <h4>Default Ratings {/*this.renderEditLink(1)*/}</h4>
            </div>
            <div className="row">
              <div className="col-md-12">
                <label>Invoice Pricing</label>
                <h5>{this.props.invoicePricing || '--'}</h5>
              </div>
              <div className="col-md-12">
                <label>Vendor Relations</label>
                <h5>{this.props.vendorRelations || '--'}</h5>
              </div>
              <div className="col-md-12">
                <label>Customer Relations</label>
                <h5>{this.props.customerRelations || '--'}</h5>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
  }
}



// WEBPACK FOOTER //
// ./src/vendor/_components/vendor-info/vendor-info-default-rating.component.tsx